/** Número WhatsApp Guatemala (solo dígitos, sin +) para wa.me */
export const WHATSAPP_E164 = "50239559377";

/** Texto mostrado en la interfaz */
export const WHATSAPP_DISPLAY = "+502 3955 9377";

/** Mensaje prellenado al tocar el logo (cotización accesorios) */
export const WHATSAPP_COTIZACION_ACCESORIO_MESSAGE = `¡Hola Armería AK-47! 👋

Estoy interesado en cotizar un accesorio de su tienda 🛒🔫✨

📞 ${WHATSAPP_DISPLAY}

¡Quedo atento! 🙏`;

export function whatsappUrl(text?: string) {
  const base = `https://wa.me/${WHATSAPP_E164}`;
  if (text && text.length > 0) {
    return `${base}?text=${encodeURIComponent(text)}`;
  }
  return base;
}
